import { Step } from "react-joyride";

/**
 * Guided tour steps for the Clarifications step (panel review mode).
 *
 * Each step targets a `data-testid` attribute rendered in the step.
 * If a target isn't present, Joyride will auto-skip it.
 */
export const clarificationsReviewSteps: Step[] = [
	{
		target: '[data-testid="clarification-review-table"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Clarification Review</h3>
				<p>
					This table shows all clarification questions proposed by panel members.
					Click on a row to review the full details and decide whether to accept,
					decline, or mark as a duplicate.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="select-all-checkbox"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Batch Selection</h3>
				<p>
					Select multiple clarifications to perform batch actions — accept them
					all at once, decline with a reason, or mark a group as duplicates.
				</p>
			</div>
		),
		placement: "right",
		disableBeacon: true,
	},
	{
		target: '[data-testid="tab-accepted-clarifications"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Clarifications Register</h3>
				<p>
					Switch to this tab to view all accepted clarifications that will be
					sent to suppliers. You can review and edit them before finalising.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
];
